<script setup lang="ts">
import SolidStar01 from '@docue/docue-ui-v2/icons/SolidStar01.vue'

import type { QuoteContent } from '~/types/storyblok/appConfig'

const props = defineProps<{
  content: QuoteContent
}>()

const titleAndCompany = computed(() => [props.content.job_title, props.content.company_name].filter(Boolean).join(', '))
</script>

<template>
  <div class="flex flex-col items-center">
    <p class="mb-8 max-w-5xl text-center text-2xl font-medium">
      {{ content.short_quote }}
    </p>

    <figure
      v-if="content.person_photo?.filename"
      class="mb-4 size-16 overflow-hidden rounded-full"
    >
      <img
        class="block size-16 object-cover object-center"
        :src="`${content.person_photo.filename}/m/80x80/smart`"
        :alt="content.person_photo.alt"
      >
    </figure>

    <span class="text-base font-semibold">
      {{ props.content.person_name }}
    </span>
    <span class="text-sm text-gray-500">
      {{ titleAndCompany }}
    </span>

    <span class="mt-4 flex gap-1">
      <SolidStar01
        v-for="star in 5"
        :key="star"
        class="size-5 text-yellow-400"
      />
    </span>
  </div>
</template>
